import { Button, Form, Image, } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, register } from "../../redux/features/auth/thunk";
import { getProduct } from "../../redux/features/product/thunk";
import { validateEmail } from "../../utils/validations/validations";
import { Link, useNavigate } from "react-router-dom";

const Register = () => {
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [passwordErr, setpasswordErr] = useState("");
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault()
    let emailMsg = "";
    let passwordMsg = "";
    let nameMsg = "";
    let check = true;
    if (email === "") {
      emailMsg = "Email is Required"
      check = false;
    } else {
      emailMsg = validateEmail(email);
      if (emailMsg) check = false;
    }
    if (password === "") {
      passwordMsg = "Password is required"
      check = false;
    }
    if (userName === "") {
      nameMsg = "usename is required"
      check = false;
    }
    setEmailErr(emailMsg);
    setpasswordErr(passwordMsg);
    if (check) {
      let payload = {
        email: email,
        password: password,
        userName: userName
      }
      console.log(payload, "payload in front enddddddddddd 1122")
      dispatch(register(payload))
      // navigate('/login')
    }
  };

  useEffect(() => {
    dispatch(getProduct())
  }, [])
  

  return (
    <>
      <Form>
        <div class="form-group">
          <Form.Label for="exampleInputEmail1">Email address</Form.Label>
          <Form.Control type="email"
            onChange={(event) => {
              setEmail(event.target.value);
            }}
            value={email} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" />
        </div>
        <div class="form-group">
          <Form.Label for="exampleInputEmail1">userName</Form.Label>
          <Form.Control type="text"
            onChange={(event) => {
              setUserName(event.target.value);
            }}
            value={userName} class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter user name" />
        </div>
        <div class="form-group">
          <Form.Label for="exampleInputPassword1">Password</Form.Label>
          <Form.Control type="password" onChange={(event) => {
            setPassword(event.target.value);
          }}
            value={password} class="form-control" id="exampleInputPassword1" placeholder="Password" />
        </div>
        <Button type="submit" onClick={(e) => handleSubmit(e)} class="btn btn-primary">Register</Button>
        <Link to={'/login'}>back</Link>
      </Form>
    </>

  );
};

export default Register;